export default {
  path: '/profile_parameter_set_values',
  name: 'profile_parameter_set_values',
  component: () => import('../components/profileparametersetvalue/Layout'),
  redirect: { name: 'ProfileParameterSetValueList' },
  children: [
    /*
    {
      name: 'ProfileParameterSetValueList',
      path: '',
      component: () => import('../views/profileparametersetvalue/List')
    },
    {
      name: 'ProfileParameterSetValueCreate',
      path: 'new',
      component: () => import('../views/profileparametersetvalue/Create')
    },
    {
      name: 'ProfileParameterSetValueUpdate',
      path: ':id/edit',
      component: () => import('../views/profileparametersetvalue/Update')
    },
    {
      name: 'ProfileParameterSetValueShow',
      path: ':id',
      component: () => import('../views/profileparametersetvalue/Show')
    }
    */
  ]
};
